import { AssessmentResolver } from "views/foundation/notification/resolvers/AssessmentResolver";
import { AwardResolver } from "views/foundation/notification/resolvers/AwardResolver";
import { FoundationResolver } from "views/foundation/notification/resolvers/FoundationResolver";
import { KnowledgeResolver } from "views/foundation/notification/resolvers/KnowledgeResolver";
import { LmsResolver } from "views/foundation/notification/resolvers/LmsResolver";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";

export const MessengerResolvers: Array<typeof MessengerResolver> = [
    FoundationResolver,
    KnowledgeResolver,
    LmsResolver,
    AssessmentResolver,
    AwardResolver
];

